import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import OneFormSection from "@components/Pages/One/OneFormSection/OneFormSection"
import WebstoreHeader from "@components/Pages/Webstore/WebstoreHeader/WebstoreHeader"
import WebstoreIntroSection from "@components/Pages/Webstore/WebstoreIntroSection/WebstoreIntroSection"
import WebstoreOneSection from "@components/Pages/Webstore/WebstoreOneSection/WebstoreOneSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import WebstorePage from "@jsons/webstorePage.json"
import React from "react"

type Props = {}

const integrations = (props: Props) => {
	const pageData = getTranslatedPageData(WebstorePage, undefined, true)
	const mainContentPageData = getValueOrThrow(pageData.AdvancedSideAsset)

	return (
		<>
			<HeadMeta meta={pageData.metaData} />
			<WebstoreHeader data={getValueOrThrow(pageData.heroData)} />
			<ContainerWrapper>
				<WebstoreIntroSection
					data={getValueOrThrow(
						mainContentPageData?.[0]?.mainContent?.[0],
					)}
				/>
			</ContainerWrapper>
			<ContainerWrapper>
				<Separator size={128} />

				<WebstoreOneSection
					data={mainContentPageData?.[1]?.mainContent?.[0]}
					dataPricing={mainContentPageData[2]}
				/>
			</ContainerWrapper>
			<OneFormSection data={mainContentPageData[3]} />
		</>
	)
}

export default integrations
